import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';

// Automatikus iktató: PDF feltöltés → a backend a szövegben keresi a tárolt hivatkozási
// számokat. Egy egyezés → auto-iktatás. Több/nincs → kézi ügyválasztás (a fájl újraküldésével).
@Component({
  selector: 'app-caesar-iktato',
  templateUrl: './iktato.component.html',
  styleUrls: ['./iktato.component.scss'],
})
export class IktatoComponent implements OnInit {
  intezmeny = '';
  feldolgozas = false;
  fajl: File | null = null;
  eredmeny: any = null;        // backend válasz
  valasztottUgy = '';
  ugyek: any[] = [];
  hatosagok: any[] = [];
  ujHatosag = '';

  constructor(private http: HttpClient, private data: DataService, private router: Router, private toast: ToastController) {}

  async ngOnInit() {
    const si = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = si?.intezmenyId || '';
    this.ugyek = await firstValueFrom(this.http.get<any[]>('/api/caesar/ugyek/' + this.intezmeny));
    this.hatosagok = await firstValueFrom(this.http.get<any[]>('/api/caesar/hatosagok/' + this.intezmeny));
  }

  async fajlValt(ev: any) {
    const f: File = ev.target.files?.[0];
    if (!f) return;
    this.fajl = f;
    this.eredmeny = null;
    this.valasztottUgy = '';
    await this.iktat();
    ev.target.value = '';
  }

  async iktat() {
    if (!this.fajl) return;
    this.feldolgozas = true;
    const fd = new FormData();
    fd.append('file', this.fajl, this.fajl.name);
    try {
      this.eredmeny = await firstValueFrom(this.http.post<any>('/api/caesar/iktat/' + this.intezmeny, fd));
      if (this.eredmeny.iktatva) this.ok('Automatikusan beiktatva: ' + this.eredmeny.ugyazonosito);
    } catch { this.hiba('Nem sikerült feldolgozni a PDF-et.'); }
    finally { this.feldolgozas = false; }
  }

  // Kézi iktatás a kiválasztott ügybe (a már feltöltött fájl újraküldésével, beérkező iratként).
  async iktatIde(ugyId: string) {
    if (!this.fajl || !ugyId) return this.hiba('Válassz ügyet.');
    this.feldolgozas = true;
    const fd = new FormData();
    fd.append('file', this.fajl, this.fajl.name);
    fd.append('intezmeny', this.intezmeny);
    fd.append('irany', 'beerkezo');
    fd.append('nev', this.fajl.name);
    try {
      await firstValueFrom(this.http.post('/api/caesar/irat/' + ugyId, fd));
      this.ok('Beiktatva a kiválasztott ügybe.');
      this.eredmeny = { iktatva: true, ugy_id: ugyId, ugyazonosito: this.ugyek.find((u) => u.id === ugyId)?.ugyazonosito || '' };
    } catch { this.hiba('Nem sikerült iktatni.'); }
    finally { this.feldolgozas = false; }
  }

  ujLap() { this.eredmeny = null; this.fajl = null; this.valasztottUgy = ''; }
  ugyhoz(id: string) { this.router.navigateByUrl('/caesar/ugy/' + id); }

  /* ---- hatóságok ---- */
  async hatosagAdd() {
    if (!this.ujHatosag.trim()) return;
    await firstValueFrom(this.http.post('/api/caesar/hatosag', { intezmeny: this.intezmeny, nev: this.ujHatosag.trim() }));
    this.ujHatosag = '';
    this.hatosagok = await firstValueFrom(this.http.get<any[]>('/api/caesar/hatosagok/' + this.intezmeny));
  }
  async hatosagTorol(h: any) {
    await firstValueFrom(this.http.delete('/api/caesar/hatosag/' + h.id));
    this.hatosagok = await firstValueFrom(this.http.get<any[]>('/api/caesar/hatosagok/' + this.intezmeny));
  }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2200, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 2800, color: 'danger' })).present(); }
}
